import ReactGA from "react-ga";

export function logPageView() {
    ReactGA.initialize("UA-154283902-1");
    ReactGA.pageview(window.location.pathname);
}